/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { ConversationThreadContainer_comment$ref } from "./ConversationThreadContainer_comment.graphql";
import { ReplyListContainer1_comment$ref } from "./ReplyListContainer1_comment.graphql";
declare const _PermalinkViewContainer_comment$ref: unique symbol;
export type PermalinkViewContainer_comment$ref = typeof _PermalinkViewContainer_comment$ref;
export type PermalinkViewContainer_comment = {
    readonly id: string;
    readonly " $fragmentRefs": ConversationThreadContainer_comment$ref & ReplyListContainer1_comment$ref;
    readonly " $refType": PermalinkViewContainer_comment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PermalinkViewContainer_comment",
    "type": "Comment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ConversationThreadContainer_comment",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_comment",
            "args": null
        }
    ]
} as any);
(node as any).hash = '89988be0940e0abdbe5b540429761854';
export default node;
